<template>
  <b-form
    @submit.prevent="submitSignIn"
    novalidate
    >
    <b-form-group
      label="E-mail:"
      label-for="signInEmailInput"
      >
      <b-form-input
        id="signInEmailInput"
        type="email"
        required
        placeholder="example@domain.com"
        autocomplete="on"
        v-model.trim="$v.email.$model"
        :class="{ 'is-invalid': $v.email.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.email.required">E-mail field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.email.eamil && $v.email.required">
        E-mail field must contain valid E-mail address
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      label="Password:"
      label-for="signInPasswordInput"
      >
      <b-form-input
        id="signInPasswordInput"
        type="password"
        required
        autocomplete="on"
        v-model.trim="$v.password.$model"
        :class="{ 'is-invalid': $v.password.$error }"
        :disabled="authInProgress"
        >
      </b-form-input>
      <b-form-invalid-feedback v-if="!$v.password.required">Password field is required</b-form-invalid-feedback>
      <b-form-invalid-feedback v-if="!$v.password.minLength && $v.password.required">
        Password must have at least {{$v.password.$params.minLength.min}} letters
      </b-form-invalid-feedback>
    </b-form-group>
    <div class="oauth">
      <a
        href="#"
        class="oauth__link"
        @click.prevent="oAuthSignIn('google')"
        v-b-tooltip.hover.top
        title="Sign in with Google"
        >
        <img src="@/assets/imgs/icons/google.svg" class="oauth__img" alt="Google">
      </a>
    </div>
    <div>
      <b-button
        variant="info"
        class="authForm__submit"
        type="submit"
        :disables="authInProgress"
        >
        Submit
      </b-button>
    </div>
  </b-form>
</template>

<script>
// modules
import { mapState } from 'vuex'
import { required, minLength, email } from 'vuelidate/lib/validators'
// services
import auth from '@/services/auth'
import db from '@/services/db'

export default {
  data () {
    return {
      email: '',
      password: '',
      logo:null
    }
  },
  computed: {
    ...mapState([
      'authInProgress'
    ])
  },
  methods: {
    submitSignIn () {
      if (this.authInProgress) return
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.$store.commit('addProcess', {
        process: 'signIn',
        message: 'Sign in'
      })
      this.$store.commit('destroyCasl')
      auth.signIn(this.email, this.password, (err) => {
        this.$store.commit('deleteProcess', 'signIn')
        if (err) this.$store.commit('addError', err.message)
      })
    },
    oAuthSignIn (provider) {
      switch (provider) {
        case 'google': auth.signInWithGoogle()
          break
      }
    }
  },

  validations: {
    email: {
      required,
      email
    },
    password: {
      required,
      minLength: minLength(6)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Auth/SignIn.vue